import { Select } from 'antd'
import { SmallSpinner } from 'portal/lib/primitives'
import PropTypes from 'prop-types'
import _ from 'lodash'

function dropdownRender(menu, name, state, projectId) {
  if (_.get(state.options, [projectId, name, 'loading'], true)) {
    return (
      <div style={{ textAlign: 'center' }}>
        <SmallSpinner />
      </div>
    )
  }
  if (state.options[projectId][name].error !== null) {
    return <div> An error occured while loading options.</div>
  }
  return menu
}

export function RecordsSelect(
  name,
  state,
  fetchOptions,
  filters,
  updateFilter,
  projectId,
  tableId
) {
  // Pre-load options for assignedTo filter, check the number of options is greater than 1 (as there is always an 'Unassigned' option)
  if (name === 'assignedTo') {
    if (_.get(state.options, [projectId, name]) === undefined) {
      fetchOptions(name)
    } else if (_.get(state.options, [projectId, name, 'options'])?.length < 2) {
      setTimeout(() => {
        fetchOptions(name)
      }, 0)
    }
  }

  const dropdownOptions = []

  Array(..._.get(state.options, [projectId, name, 'options'], []))
    .filter(option => option && /\S/.test(option))
    .sort((a, b) =>
      a.label
        ? a.label.localeCompare(b.label, 'en', { sensitivity: 'base' })
        : a.localeCompare(b, 'en', { sensitivity: 'base' })
    )
    // Options can be an array of strings or objects with 'key' & 'label' properties
    .map(option =>
      dropdownOptions.push({
        key: option.key || option,
        value: option.key || option,
        label: option.label || option
      })
    )

  return (
    <Select
      className="records-filter-select"
      autoFocus
      autoClearSearchValue={false}
      maxTagCount="responsive"
      popupMatchSelectWidth={false}
      mode="multiple"
      showSearch
      allowClear
      style={{ width: '100%' }}
      options={dropdownOptions}
      popupRender={menu => dropdownRender(menu, name, state, projectId)}
      filterOption={(input, option) =>
        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
      }
      data-testid={`${name}Filter`}
      onOpenChange={isVisible => {
        if (
          isVisible &&
          _.get(state.options, [projectId, name]) === undefined
        ) {
          fetchOptions(name)
        }
      }}
      getPopupContainer={() => document.getElementById(tableId)}
      value={filters[name]}
      onChange={value => {
        updateFilter(name, value)
      }}
    />
  )
}

RecordsSelect.propTypes = {
  name: PropTypes.string,
  state: PropTypes.object,
  fetchOptions: PropTypes.func,
  filters: PropTypes.object,
  updateFilter: PropTypes.func
}
